import { render, staticRenderFns } from "./Newness.vue?vue&type=template&id=76a6080d&"
import script from "./Newness.vue?vue&type=script&lang=js&"
export * from "./Newness.vue?vue&type=script&lang=js&"
import style0 from "./Newness.vue?vue&type=style&index=0&id=76a6080d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports